const {
  REACT_APP_SERVER_BASE_URL,
  REACT_APP_FRONTEND_BASE_URL,
  REACT_APP_FRONTEND_APP,
  REACT_APP_API_KEY,
  REACT_APP_FRONTEND_COLLAB,
  REACT_APP_CP_SIGN_ALL_ENABLED,
  REACT_APP_CP_AGREEMENTS_ENABLED,
} = process.env;

const envs = {
  serverBaseUrl: REACT_APP_SERVER_BASE_URL,
  frontendBaseUrl: REACT_APP_FRONTEND_BASE_URL,
  frontendAppUrl: REACT_APP_FRONTEND_APP,
  frontendCollabUrl: REACT_APP_FRONTEND_COLLAB,
  apiKey: REACT_APP_API_KEY,
};

export const serverBaseUrl = envs.serverBaseUrl;
export const frontendBaseUrl = envs.frontendBaseUrl;
export const frontendAppUrl = envs.frontendAppUrl;
export const apiKey = envs.apiKey;
export const frontendCollabUrl = envs.frontendCollabUrl;
// ENG-1865: "Review and sign all" is off unless the build sets this to exactly "true".
export const cpSignAllEnabled = REACT_APP_CP_SIGN_ALL_ENABLED === "true";
// ENG-2121: build-time mirror of CP_AGREEMENTS_ENABLED; CP document drafts stay hidden unless this is exactly "true".
export const cpAgreementsEnabled = REACT_APP_CP_AGREEMENTS_ENABLED === "true";
export default envs;
